// Unpublished Work © 2026 Deere & Company.

export const INVALID_RESPONSE_CODE = 'Invalid response code';
